<template lang="pug">
.user-avatar(
  :class="avatarClasses"
)
  img(
    :src="user.avatar"
  )
</template>

<script>
const SIZE_CLASSSIZE_MAP = {
  xlarge: '--xl',
  xl: '--xl',
  large: '--l',
  l: '--l',
  medium: '', // no modifier for medium
  m: '',
  small: '--s',
  s: '--s',
  xsmall: '--xs',
  xs: '--xs',
}

export default {
  name: 'user-avatar',
  props: {
    user: {
      type: Object,
    },
    size: {
      type: String,
      default: '',
      validator: value =>
        !value || Object.keys(SIZE_CLASSSIZE_MAP).includes(value),
    },
  },
  computed: {
    avatarClasses() {
      return [this.size ? SIZE_CLASSSIZE_MAP[this.size] : '']
    },
  },
}
</script>

<style lang="sass">
.user-avatar
  display: block
  overflow: hidden
  border-radius: 100%
  width: 4rem
  height: 4rem

  img
    width: 100%
    height: 100%

  &.--xl
    width: 6rem
    height: 6rem  
  &.--l
    width: 5rem
    height: 5rem
  &.--s
    width: 3rem
    height: 3rem
  &.--xs
    width: 2rem
    height: 2rem
</style>
